// extracted by mini-css-extract-plugin
module.exports = {"check-mark":"_3LiMl-","checkMark":"_3LiMl-","nx-svg--disabled":"_1hWIW-","nxSvgDisabled":"_1hWIW-","nx-svg--active":"AzaUp-","nxSvgActive":"AzaUp-"};